const defaultState = {
	plants: [],
	useYnList: [],
	searchParams: {
		plantCd: '',
		userName: null,
		userId: null
	},
	users: {
		resultList: [],
		pagingInfo: {}
	},
	groups: [],
	mappingGroups: []
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
